import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, X, Expand } from 'lucide-react';
import { GamePreview, DISCORD_URL } from '../content/community';

export function ApplyLink({ children = 'How to join' }: { children?: React.ReactNode }) {
  return <Link className="d-button d-button-primary" to="/apply">{children}<ArrowUpRight size={18} aria-hidden="true" /></Link>;
}
export function DiscordLink() {
  return <a className="d-button d-button-discord" href={DISCORD_URL} target="_blank" rel="noreferrer">Join Discord<ArrowUpRight size={18} aria-hidden="true" /></a>;
}
export function Preview({ feature }: { feature: GamePreview }) {
  const dialog = useRef<HTMLDialogElement>(null);
  const trigger = useRef<HTMLButtonElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!('IntersectionObserver' in window)) { setVisible(true); return; }
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { setVisible(true); observer.disconnect(); }
    }, { rootMargin: '250px' });
    if (trigger.current) observer.observe(trigger.current);
    return () => observer.disconnect();
  }, []);
  const visual = <svg viewBox={feature.viewBox} role="img" aria-label={feature.alt} width="1100" className="d-game-image">
    {visible && <image href={feature.image} width="2790" height="2324" />}
  </svg>;
  return <>
    <button ref={trigger} className="d-preview" onClick={() => { setVisible(true); dialog.current?.showModal(); }} aria-label={`Enlarge ${feature.caption}`}>
      {visual}<span className="d-preview-caption">{feature.caption}<Expand size={16} aria-hidden="true" /></span>
    </button>
    <dialog aria-label={`${feature.caption} enlarged preview`} ref={dialog} className="d-lightbox" onClose={() => trigger.current?.focus()} onClick={e => { if (e.target === dialog.current) dialog.current.close(); }}>
      <div className="d-lightbox-head"><p>{feature.caption}</p><button autoFocus onClick={() => dialog.current?.close()} aria-label="Close preview"><X /></button></div>
      <div className="d-lightbox-image" tabIndex={0} role="region" aria-label="Scrollable game screenshot">{visual}</div><p className="d-lightbox-note">Development preview. Features and balance are being tested. On a small screen, scroll sideways to see the full picture.</p>
    </dialog>
  </>;
}
export function JoinBanner() {
  return <section className="d-join-banner"><div><span className="d-eyebrow">COME TRY DARUMA</span><h2>Come meet the server.</h2><p>Ask about a class, check the previews or get help joining.</p></div><div className="d-actions"><DiscordLink /><ApplyLink /></div></section>;
}
